import React, { Component } from 'react';

interface FileInputProps {
  handleAvatarSrc: (fileSrc: string) => void;
}

export default class FileInput extends Component<FileInputProps> {
  inputFile: React.RefObject<HTMLInputElement> = React.createRef();
  imageSrc = '';

  handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    const reader = new FileReader();

    if (files) {
      reader.readAsDataURL(files[0]);
    }

    reader.onload = () => {
      if (reader.result) {
        this.imageSrc = reader.result.toString();
        this.props.handleAvatarSrc(this.imageSrc);
      }
    };
  };

  render() {
    return (
      <div className="form__avatar" data-testid="file-input">
        <label htmlFor="file" className="label">
          Upload your avatar:
        </label>
        <input
          type="file"
          className="form__file"
          id="file"
          name="avatar"
          ref={this.inputFile}
          onChange={(e) => this.handleChangeFile(e)}
        />
      </div>
    );
  }
}
